import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from "react-router";
import HeaderFooterwithCookies from  '../common/openPages/HeaderFooterwithCookies';
import MultiDashboard from '../multiUserDashboard/MultiDashboard';
import axios from 'axios';
import { CircularProgress } from '@material-ui/core';
import { smlUrl } from '../../utils/config';
const SwitchEcosystem = props => {
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const { search } = location;
  // const returnPage = querystring.parse(search).return_url;
  const returnPage = search
    ? search.substring(search.indexOf("/pcmp"))
    : search;
  
  useEffect(() => {
      axios
        .get(`${smlUrl}/sml/getUserEcosystems`)
        .then((res) => {
          if (res.data.status) {
            if (
              res.data.userEcosystems &&
              Array.isArray(res.data.userEcosystems)
            ) {
              if (
                res.data.userEcosystems.length == 1 &&
                res.data.userEcosystems[0].ecosystem_id ===
                  parseInt(localStorage.ecosystemId)
              ) {
                history.push(returnPage || "/pcmp/mosymphony/useraccess");
              } 
            }
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          setLoading(false);
        });
  }, []);
  
  return (
    loading
        ?
        <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width:'100%',
                    minHeight: "100vh",
                  }}
                >
                  <CircularProgress style={{ color: "primary" }} thickness={7} />
                </div>
      :
      <HeaderFooterwithCookies >
        <MultiDashboard/>
      </HeaderFooterwithCookies>
    
  );
};

export default SwitchEcosystem;